module.exports = __webpack_public_path__ + "img/04.d043a69c.jpg";